var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStarYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1093 1.74536C14.4804 1.01811 15.5196 1.01811 15.8907 1.74536L19.2653 8.3579C19.4106 8.64262 19.6833 8.84072 19.999 8.89092L27.3307 10.057C28.137 10.1852 28.4581 11.1735 27.8812 11.7512L22.6351 17.004C22.4092 17.2302 22.305 17.5507 22.3548 17.8665L23.5115 25.1997C23.6387 26.0062 22.798 26.617 22.0703 26.2468L15.4534 22.8807C15.1685 22.7357 14.8315 22.7357 14.5466 22.8807L7.92972 26.2468C7.202 26.617 6.36131 26.0062 6.48851 25.1997L7.64516 17.8665C7.69496 17.5507 7.59081 17.2302 7.36493 17.004L2.11884 11.7512C1.54188 11.1735 1.86299 10.1852 2.66933 10.057L10.001 8.89092C10.3167 8.84072 10.5894 8.64262 10.7347 8.3579L14.1093 1.74536Z",
    fill: "#EEA42E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarYellow);
export default __webpack_public_path__ + "static/media/icon_star_yellow.be2d5497b9c7750279a04ee2da824874.svg";
export { ForwardRef as ReactComponent };